'use strict';

customerZone

    .config( ['$provide', function ($provide){
        if (window.enableNgRouting) return;

        //see https://stackoverflow.com/questions/18611214/turn-off-url-manipulation-in-angularjs
        $provide.decorator('$browser', ['$delegate', function ($delegate) {
            $delegate.onUrlChange = function () {};
            $delegate.url = function () { return ''; };
            return $delegate;
        }]);
    }])

    .config(['$locationProvider', '$routeProvider', 'configProvider', function config($locationProvider,
                                                                                      $routeProvider, configProvider){
        if (!window.enableNgRouting) {
            $routeProvider.eagerInstantiationEnabled(false);
            return;
        }

        var config = configProvider.$get();

        var accessConditions = {
            subscriptionRequired: function(session) {
                return session && session.subscriber();
            },
            subscriptionEnabled: function(session) {
                return session && session.subscriber() && session.subscriber().state === jim.SubscriptionState.enabled;
            },
            simRequired: function(session) {
                return session && session.subscriber() && session.subscriber().sim;
            },
            postpaidOnly: function(session) {
                return session && session.subscriber() && session.subscriber().isPostpaid();
            },
            prepaidOnly: function(session) {
                return session && session.subscriber() && session.subscriber().isPrepaid();
            },
            notLoggedIn: function(session) {
                return !session.authenticated();
            },
            hasInvoices: function(session) {
                return session.flags('hasInvoices');
            }
        };

        /**
         * Simple combination function to combine access conditions
         */
        var and = function(){
            var operands = arguments;
            return function(session){
                for (var i=0; i<operands.length; i++){
                    if (!operands[i](session)) return false;
                }
                return true;
            };
        };

        /**
         * Simple combination function to combine access conditions
         */
        var or = function(){
            var operands = arguments;
            return function(session){
                for (var i=0; i<operands.length; i++){
                    if (operands[i](session)) return true;
                }
                return false;
            };
        };

        $routeProvider
            .when('/about', {
                templateUrl: config.baseUrl+'/views/about.html',
                controller: 'AboutController as eservice',
                title: 'title_about_jim_web'
            })
            .when('/login', {
                templateUrl: config.baseUrl+'/views/login.html',
                controller: 'LoginController as eservice',
                title: 'title_log_in',
                notificationContexts: ['jim_login']
            })
            .when('/reset_password', {
                templateUrl: config.baseUrl+'/views/reset_password.html',
                controller: 'ResetPasswordController as eservice',
                title: 'title_forgot_password'
            })
            .when('/create_customer', {
                templateUrl: config.baseUrl+'/views/create_customer.html',
                controller: 'CreateCustomerController as eservice',
                accessible: accessConditions.notLoggedIn,
                title: 'title_create_account'
            })
            .when('/registration', {
                redirectTo: '/registration/sales'
            })
            .when('/registration/sales', {
                templateUrl: config.baseUrl+'/views/registration/registration_wizard.html',
                controller: 'RegistrationController as eservice',
                title: 'title_registration',
                reloadOnUrl: false,
                reloadOnSearch: false,
                notificationContexts: ['jim_payments', 'jim_top_ups']
            })
            .when('/registration/mnp', {
                templateUrl: config.baseUrl+'/views/registration/mnp.html',
                controller: 'MnpController as eservice',
                title: 'title_mnp',
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_payments']
            })
            .when('/registration/activate', {
                templateUrl: config.baseUrl+'/views/registration/activation.html',
                controller: 'ActivationController as eservice',
                requiresAuth: true,
                authExplanation: 'login_explanation_activate',
                emailLoginOnly: true,
                title: 'title_sim_activation',
                notificationContexts: ['jim_activation']
            })
            .when('/migration', {
                templateUrl: config.baseUrl+'/views/migration.html',
                controller: 'MigrationController as eservice',
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                title: 'title_change_product'
            })
            /***************************** Main menu and context menu *************************************************/
            // standalones
            .when('/reload', {
                templateUrl: config.baseUrl+'/views/topup.html',
                controller: 'TopupController as eservice',
                title: 'title_topup_online',
                authExplanation: 'login_explanation_topup',
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_payments', 'jim_top_ups']
            })
            .when('/my_orders', {
                templateUrl: config.baseUrl+'/views/my_orders.html',
                controller: 'MyOrdersController as eservice',
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                title: 'title_orders'
            })
            .when('/my_products', {
                templateUrl: config.baseUrl+'/views/my_products.html',
                controller: 'MyProductsController as eservice',
                accessible: accessConditions.subscriptionRequired,
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                title: 'title_products'
            })
            .when('/my_products/aliases', {
                templateUrl: config.baseUrl+'/views/aliases.html',
                controller: 'AliasesController as eservice',
                accessible: accessConditions.subscriptionRequired,
                requiresAuth: true,
                reloadOnSubscriptionChange: false,
                title: 'title_subscriptions'
            })
            .when('/my_products/cancel', {
                templateUrl: config.baseUrl+'/views/cancel_subscription.html',
                controller: 'CancelSubscriptionController as eservice',
                accessible: accessConditions.subscriptionRequired,
                requiresAuth: true,
                reloadOnSubscriptionChange: true,
                title: 'title_cancel_subscription'
            })
            // Mijn facturen / Mes factures
            .when('/invoices/history', {
                templateUrl: config.baseUrl+'/views/invoice_history.html',
                controller: 'InvoiceHistoryController as eservice',
                requiresAuth: true,
                accessible: or(accessConditions.postpaidOnly, accessConditions.hasInvoices),
                context: {id: 'title_invoices', position: 1},
                title: 'title_invoice_overview'
            })
            .when('/invoices/payment_setup', {
                templateUrl: config.baseUrl+'/views/invoice_payment_setup.html',
                controller: 'PaymentSetupController as eservice',
                accessible: accessConditions.postpaidOnly,
                context: {id: 'title_invoices', position: 2},
                title: 'title_payment_settings',
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_doccle', 'jim_mollie_mandates']
            })
            .when('/invoices/pay', {
                templateUrl: config.baseUrl+'/views/invoice_history.html',
                controller: 'InvoiceHistoryController as eservice',
                requiresAuth: true,
                accessible: or(accessConditions.postpaidOnly, accessConditions.hasInvoices),
                context: {id: 'title_invoices', position: 3},
                title: 'title_pay_an_invoice',
                notificationContexts: ['jim_payments']
            })
            .when('/payment_invitations/history', {
                templateUrl: config.baseUrl+'/views/invoice_history.html',
                controller: 'InvoiceHistoryController as eservice',
                requiresAuth: true,
                accessible: or(accessConditions.postpaidOnly, accessConditions.hasInvoices),
                context: {id: 'title_payment_invitations', position: 1},
                title: 'title_invoice_overview'
            })
            .when('/payment_invitations/payment_setup', {
                templateUrl: config.baseUrl+'/views/invoice_payment_setup.html',
                controller: 'PaymentSetupController as eservice',
                accessible: accessConditions.postpaidOnly,
                requiresAuth: true,
                context: {id: 'title_payment_invitations', position: 2},
                title: 'title_payment_settings',
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_doccle', 'jim_mollie_mandates']
            })
            .when('/payment_invitations/pay', {
                templateUrl: config.baseUrl+'/views/invoice_history.html',
                controller: 'InvoiceHistoryController as eservice',
                requiresAuth: true,
                accessible: or(accessConditions.postpaidOnly, accessConditions.hasInvoices),
                context: {id: 'title_payment_invitations', position: 3},
                title: 'title_pay_an_invoice',
                notificationContexts: ['jim_payments']
            })
            // Mijn historiek / Mon historique
            .when('/usage_history', {
                templateUrl: config.baseUrl+'/views/usage_history.html',
                controller: 'UsageHistoryController as eservice',
                requiresAuth: true,
                accessible: accessConditions.simRequired,
                context: {id: 'title_my_history', position: 1},
                title: 'title_usage_records',
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_usage']
            })
            .when('/usage_overview', {
                templateUrl: config.baseUrl+'/views/my_usage.html',
                controller: 'MyUsageController as eservice',
                requiresAuth: true,
                accessible: accessConditions.subscriptionEnabled,
                context: {id: 'title_my_history', position: 2},
                title: 'title_usage_overview',
                reloadOnSubscriptionChange: true,
                notificationContexts: ['jim_balance']
            })
            .when('/topup_history', {
                templateUrl: config.baseUrl+'/views/topup_history.html',
                controller: 'TopupHistory as eservice',
                requiresAuth: true,
                accessible: and(accessConditions.prepaidOnly, accessConditions.simRequired),
                context: {id: 'title_my_history', position: 3},
                reloadOnSubscriptionChange: true,
                title: 'title_topup_overview'
            })
            // Mijn gegevens / Mes données
            .when('/contact_data', {
                templateUrl: config.baseUrl+'/views/contact_data.html',
                controller: 'MySettingsController as eservice',
                requiresAuth: true,
                context: {id: 'title_data', position: 1},
                title: 'title_data'
            })
            .when('/settings/password', {
                templateUrl: config.baseUrl+'/views/settings_password.html',
                controller: 'MySettingsController as eservice',
                requiresAuth: true,
                context: {id: 'title_data', position: 2},
                title: 'title_change_password'
            })
            // Mijn instellingen / Mes préférences
            .when('/settings/notifications', {
                templateUrl: config.baseUrl+'/views/settings_notifications.html',
                controller: 'NotificationSettingsController as eservice',
                requiresAuth: true,
                accessible: accessConditions.simRequired,
                context: {id: 'title_settings', position: 2},
                title: 'title_notification_settings'
            })
            .when('/settings/sim', {
                templateUrl: config.baseUrl+'/views/settings_sim.html',
                controller: 'MySimController as eservice',
                requiresAuth: true,
                accessible: accessConditions.simRequired,
                context: {id: 'title_settings', position: 3},
                reloadOnSubscriptionChange: true,
                title: 'title_sim_info'
            })
            .when('/simswap18', {
                redirectTo: '/settings/sim'
            })
            .when('/address', {
                redirectTo: '/contact_data'
            })
            /* TODO: auto-topup: out of scope for now.
            .when('/topups/auto', {
                templateUrl: config.baseUrl+'/views/topups_payment_setup.html',
                controller: 'PaymentSetupController as eservice',
                context: {id: 'title_settings', position: 4},
                accessible: accessConditions.prepaidOnly,
                title: 'title_automatic_topup',
                requiresAuth: true
            })*/
            .when('/', {
                templateUrl: config.baseUrl+'/views/home.html',
                title: 'title_eservices_home'
            })
            .otherwise({
                templateUrl: config.baseUrl+'/views/404.html',
                title: 'title_page_not_found'
            });
    }]);
